import { IGuestlistBlockStatus, IGuestlistBlockType } from "Bands/types";
import { copy } from "shared/assets";
import { BoldText, MutedText } from "shared/styles";
import { IFieldType, IFormFields } from "shared/types";

const fieldCopy = copy.guestlistBlock.create.properties;

export const getFields = ({
  hideTitle,
  hideStatus,
  disableType,
  disableNbTickets,
}: {
  hideTitle?: boolean;
  hideStatus?: boolean;
  disableType?: boolean;
  disableNbTickets?: boolean;
}): IFormFields => {
  let fields = [] as IFormFields;

  if (!hideTitle) {
    fields = [
      {
        name: "title",
        label: fieldCopy.title,
        type: IFieldType.text,
        validation: {
          required: copy.errors.required,
        },
        style: {
          gridColumn: "span 3",
        },
      },
    ];
  }

  return [
    ...fields,
    {
      name: "status",
      label: fieldCopy.status.title,
      type: IFieldType.radioGroup,
      isInline: false,
      isHidden: hideStatus,
      options: [
        {
          label: (
            <span>
              <BoldText>{fieldCopy.status.options.open.title}</BoldText>
              <MutedText> - {fieldCopy.status.options.open.note}</MutedText>
            </span>
          ),
          value: IGuestlistBlockStatus.open,
        },
        {
          label: (
            <span>
              <BoldText>{fieldCopy.status.options.closed.title}</BoldText>
              <MutedText> - {fieldCopy.status.options.closed.note}</MutedText>
            </span>
          ),
          value: IGuestlistBlockStatus.closed,
        },
      ],
      validation: {
        required: copy.errors.required,
      },
      style: {
        gridColumn: "span 3",
      },
    },
    {
      name: "guestBlockType",
      label: fieldCopy.type.title,
      type: IFieldType.radioGroup,
      isInline: false,
      options: [
        {
          label: (
            <span>
              <BoldText>{fieldCopy.type.options.public.title}</BoldText>
              <MutedText> - {fieldCopy.type.options.public.note}</MutedText>
            </span>
          ),
          value: IGuestlistBlockType.public,
          disabled: disableType,
        },
        {
          label: (
            <span>
              <BoldText>{fieldCopy.type.options.approvalNeeded.title}</BoldText>
              <MutedText> - {fieldCopy.type.options.approvalNeeded.note}</MutedText>
            </span>
          ),
          value: IGuestlistBlockType.approval_needed,
          disabled: disableType,
        },
        {
          label: (
            <span>
              <BoldText>{fieldCopy.type.options.private.title}</BoldText>
              <MutedText> - {fieldCopy.type.options.private.note}</MutedText>
            </span>
          ),
          value: IGuestlistBlockType.private,
          disabled: disableType,
        },
      ],
      validation: {
        required: copy.errors.required,
      },
      style: {
        gridColumn: "span 3",
      },
    },
    {
      name: "maxTicketsPerEntry",
      type: IFieldType.number,
      label: fieldCopy.maxTicketsPerEntry.title,
      disabled: disableNbTickets,
      validation: {
        required: copy.errors.required,
        min: 1,
        max: 10,
      },
      style: {
        gridColumn: "span 2",
        mobile: {
          gridColumn: "span 3",
        },
      },
    },
  ];
};
